import { BaseService, BaseServiceOptions } from '../api/services/base-service';
import { PagedResponse } from '../common';
import { ReportHistory } from './interfaces';
import { SearchReportHistoriesRequest } from './reports.service.interfaces';

export class ReportsService extends BaseService {
  reportsApiUrl: string;

  constructor(opts: BaseServiceOptions) {
    super(opts);
    this.reportsApiUrl = `${this.apiUrl}/reports/v1`;
  }

  searchHistories(req: SearchReportHistoriesRequest) {
    return this.get<PagedResponse<ReportHistory>>(`${this.reportsApiUrl}/histories/search`, req);
  }
}
